import _implicitStylesheets from "./modal.css";
import _implicitScopedStylesheets from "./modal.scoped.css?scoped=true";
import _c360Icon from "c360/icon";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<h2 class="slds-text-heading_medium slds-hyphenate header-string${0}"${2}>${"t1"}</h2>`;
const $fragment2 = parseFragment`<div class="slds-backdrop slds-backdrop_open${0}"${2}></div>`;
const stc0 = {
  "slds-modal": true,
  "slds-fade-in-open": true
};
const stc1 = {
  classMap: {
    "slds-modal__container": true
  },
  key: 1
};
const stc2 = {
  "slds-modal__close": true,
  "modal-close": true
};
const stc3 = {
  classMap: {
    "slds-text-heading_medium": true,
    "slds-hyphenate": true,
    "header-slot": true
  },
  key: 6
};
const stc4 = {
  attrs: {
    "name": "header"
  },
  key: 7
};
const stc5 = [];
const stc6 = {
  classMap: {
    "slds-m-top_x-small": true,
    "modal-hidden": true
  },
  key: 8
};
const stc7 = {
  "name": "tagline"
};
const stc8 = {
  "slds-modal__content": true,
  "slds-p-around_medium": true,
  "modal-content": true
};
const stc9 = {
  key: 11
};
const stc10 = {
  classMap: {
    "slds-modal__footer": true,
    "slds-p-around_medium": true,
    "modal-hidden": true
  },
  key: 12
};
const stc11 = {
  "name": "footer"
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {gid: api_scoped_id, b: api_bind, ncls: api_normalize_class_name, c: api_custom_element, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, s: api_slot, h: api_element} = $api;
  const {_m0, _m1, _m2, _m3, _m4, _m5, _m6} = $ctx;
  return [$cmp.showModal ? api_element("section", {
    classMap: stc0,
    attrs: {
      "role": "dialog",
      "tabindex": "-1",
      "aria-labelledby": api_scoped_id("modal-heading-01"),
      "aria-modal": "true",
      "aria-describedby": api_scoped_id("modal-content-id-1")
    },
    key: 0,
    on: {
      "keydown": _m0 || ($ctx._m0 = api_bind($cmp.handleKeyboard))
    }
  }, [api_element("div", stc1, [api_element("header", {
    className: api_normalize_class_name($cmp.modalHeaderCss),
    key: 2
  }, [$cmp.showClose ? api_custom_element("c360-icon", _c360Icon, {
    classMap: stc2,
    props: {
      "iconName": "utility:close",
      "iconDescription": $cmp.i18n.shared.close,
      "size": "small",
      "iconClass": "normal",
      "tabIndex": "0",
      "role": "button"
    },
    key: 3,
    on: {
      "click": _m1 || ($ctx._m1 = api_bind($cmp.handleDialogClose)),
      "keydown": _m2 || ($ctx._m2 = api_bind($cmp.handleKeyboard))
    }
  }) : null, $cmp.hasHeaderString ? api_static_fragment($fragment1, 5, [api_static_part(1, null, api_dynamic_text($cmp.header))]) : null, !$cmp.hasHeaderString ? api_element("h2", stc3, [api_slot("header", stc4, stc5, $slotset)]) : null, api_element("p", stc6, [api_slot("tagline", {
    attrs: stc7,
    key: 9,
    on: {
      "slotchange": _m3 || ($ctx._m3 = api_bind($cmp.handleSlotTaglineChange))
    }
  }, stc5, $slotset)])]), api_element("div", {
    classMap: stc8,
    attrs: {
      "id": api_scoped_id("modal-content-id-1")
    },
    key: 10
  }, [api_slot("", stc9, stc5, $slotset)]), api_element("footer", stc10, [api_slot("footer", {
    attrs: stc11,
    key: 13,
    on: {
      "slotchange": _m4 || ($ctx._m4 = api_bind($cmp.handleSlotFooterChange))
    }
  }, stc5, $slotset)])]), api_static_fragment($fragment2, 15, [api_static_part(0, {
    on: {
      "click": _m6 || ($ctx._m6 = api_bind($cmp.handleDialogClose))
    }
  }, null)])]) : null];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.slots = ["", "footer", "header", "tagline"];
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-d8uppevbn0";
tmpl.legacyStylesheetToken = "c360-modal_modal";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
